// extracted by mini-css-extract-plugin
export default {"container":"AddLanguage_container__DbD2C"};